var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlackboxLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 144,
    viewBox: "0 0 153 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.588 2.2962H2.43976V141.73H150.588V2.2962Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.994 138.554V141.851H147.484",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.994 138.554V141.851H147.484",
    stroke: "#20263C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.734 141.851H9.16223H140.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.734 141.851H9.16223",
    stroke: "#20263C",
    strokeMiterlimit: 10,
    strokeDasharray: "5.77 5.77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79309 141.851H2.28357V138.554",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.79309 141.851H2.28357V138.554",
    stroke: "#20263C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.28357 132.213V8.61121V132.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28357 132.213V8.61121",
    stroke: "#20263C",
    strokeMiterlimit: 10,
    strokeDasharray: "5.77 5.77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.28357 5.44614V2.14923H5.79309",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28357 5.44614V2.14923H5.79309",
    stroke: "#20263C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5314 2.14923H144.115H12.5314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5314 2.14923H144.115",
    stroke: "#20263C",
    strokeMiterlimit: 10,
    strokeDasharray: "5.77 5.77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.484 2.14923H150.994V5.44614",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.484 2.14923H150.994V5.44614",
    stroke: "#20263C",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.994 11.7762V135.389V11.7762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.994 11.7762V135.389",
    stroke: "#20263C",
    strokeMiterlimit: 10,
    strokeDasharray: "5.77 5.77"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5555 31.8605L95.6342 41.6861L104.801 36.7189L77.5555 21.9041L32.0462 46.6534L41.1666 51.6208L77.5555 31.8605Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.921 41.686L77.5557 61.4465L59.4771 51.6207L50.3334 56.5881L77.5557 71.381L123.088 46.6534L113.921 41.686Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.361 74.9325L30.2175 69.9653V99.5513L75.7268 124.301V114.366L39.361 94.584V74.9325Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2175 60.0302L66.5831 79.7904V99.4419L75.7268 104.431V74.823L30.2175 50.0955V60.0302Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.63 69.9651V60.0304L79.3844 74.8235V124.3L88.5279 119.333V79.7906L106.63 69.9651Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.75 55.0628V94.5835L97.6713 104.431V114.366L124.917 99.5509V50.0955L115.75 55.0628Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackboxLogo);
export default __webpack_public_path__ + "static/media/blackbox-logo.ea7548ecde00db5372bca4b46d1a460e.svg";
export { ForwardRef as ReactComponent };